import { useId, useState } from "react";
import { ArrowUpRight, Check, Truck } from "lucide-react";
import { JobDescription, JobDescriptionBlocks, parseJobDescription } from "./job-description";

/** Role tabs display the company's own copy; selecting one never changes an application. */
export function OpportunityDetails({ description, jobTypes }: { description: string; jobTypes: string[] }) {
  const id = useId();
  const [selected, setSelected] = useState(0);
  const sections = parseJobDescription(description);
  const roles = sections.filter((section) => jobTypes.some((type) => type.trim().toLowerCase() === section.title.trim().toLowerCase()));
  if (roles.length < 2) return <JobDescription description={description}/>;
  const active = Math.min(selected, roles.length - 1);
  const supporting = sections.filter((section) => !roles.includes(section));
  return <>
    <div className="driving-roles">
      <div className="role-tabs" role="tablist" aria-label="Driving opportunities">
        {roles.map((role, index) => <button key={role.title} type="button" role="tab" id={`${id}-tab-${index}`} aria-selected={index === active} aria-controls={`${id}-panel-${index}`} tabIndex={index === active ? 0 : -1} onClick={() => setSelected(index)} onKeyDown={(event) => {
          const next = event.key === "ArrowRight" ? (index + 1) % roles.length : event.key === "ArrowLeft" ? (index - 1 + roles.length) % roles.length : event.key === "Home" ? 0 : event.key === "End" ? roles.length - 1 : null;
          if (next === null) return;
          event.preventDefault(); setSelected(next); document.getElementById(`${id}-tab-${next}`)?.focus();
        }}><Truck />{role.title}{index === active ? <Check /> : null}</button>)}
      </div>
      {roles.map((role, index) => <section key={role.title} className="role-panel" role="tabpanel" id={`${id}-panel-${index}`} aria-labelledby={`${id}-tab-${index}`} hidden={index !== active} tabIndex={0}>
        <div className="role-panel-title"><span className="section-eyebrow">FIND YOUR FIT</span><h3>{role.title}</h3><span className="role-arrow" aria-hidden="true"><ArrowUpRight /></span></div>
        <div className="offer-section"><JobDescriptionBlocks blocks={role.blocks}/></div>
      </section>)}
    </div>
    <div className="opportunity-support">{supporting.map((section, index) => section.title ? <details className="support-detail" key={index}>
      <summary><span>{section.title}</span><span className="support-plus" aria-hidden="true">+</span></summary>
      <div className="offer-section"><JobDescriptionBlocks blocks={section.blocks}/></div>
    </details> : <div className="company-intro" key={index}><JobDescriptionBlocks blocks={section.blocks}/></div>)}</div>
  </>;
}
